import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useClickOutside from '@hooks/useClickOutside';

import { filterFieldType, isDetailsPage, toggleCheckbox } from '@features/filter/static/filterUtil';

import { storeItemInGlobalFilter, storeSelectedFilterCheckboxType } from '@store/actions/FilterAction';

const CheckBoxWithAll = ({ data, handleSearch, type, filterFieldKey = '' }) => {
	const getFilterData = (store) =>
		isDetailsPage() ? store.filterFieldStore?.DETAILS_PAGE_FILTERS : store.filterFieldStore;
	const filterData = useSelector((store) => getFilterData(store));
	const selectedField = useSelector((store) => store.slectedCheckBoxFieldStore);
	const dispatch = useDispatch();
	const checkboxRef = useRef();
	const [, setCurrentSelectedField] = useState('');

	useEffect(() => {
		const existingAllFlag = data.find((item) => item?.name === 'All');
		setCurrentSelectedField(existingAllFlag?.id);
	}, [filterData, JSON.stringify(data)]);

	// useEffect(() => {
	// 	const copyData = [...data];
	// 	const existingAllFlag = copyData.find((item) => item.name === 'All');
	// 	const filterDataStore = filterData[filterFieldKey] || [];
	// 	const getAllFlagFromStore = filterDataStore.find((item) => item.key === currentSelectedField);
	// 	const filterFieldsWithoutAll = filterDataStore.filter(
	// 		(item) =>
	// 			item.value !== currentSelectedField &&
	// 			copyData.some((list) => list.name !== 'All' && item.key === list.id)
	// 	);
	// 	const dataWithoutAll = data.filter((item) => item.name !== 'All');

	// 	const shouldAddAll = () =>
	// 		filterFieldsWithoutAll.length === dataWithoutAll.length && !getAllFlagFromStore;

	// 	const shouldRemoveAll = () =>
	// 		filterFieldsWithoutAll.length !== dataWithoutAll.length &&
	// 		getAllFlagFromStore &&
	// 		getAllFlagFromStore.key === existingAllFlag.id;

	// 	// const addAllField = () => {
	// 	// 	dispatch(
	// 	// 		storeItemInGlobalFilter({
	// 	// 			name: filterFieldType[type]['idName'],
	// 	// 			key: existingAllFlag?.id,
	// 	// 			value: existingAllFlag?.name,
	// 	// 			identifier: `${filterFieldType[type]['idName']}_${existingAllFlag?.id}`,
	// 	// 			checked: true
	// 	// 		})
	// 	// 	);
	// 	// };
	// 	// console.log(filterData, 'FILTER DATA-->');
	// 	// const removeAllField = () => {
	// 	// 	dispatch(
	// 	// 		removeItemFromGlobalFilter({
	// 	// 			name: filterFieldKey,
	// 	// 			identifier: `${filterFieldKey}_${getAllFlagFromStore?.key}`
	// 	// 		})
	// 	// 	);
	// 	// };

	// 	// if (shouldAddAll()) {
	// 	// 	addAllField();
	// 	// } else if (shouldRemoveAll()) {
	// 	// 	removeAllField();
	// 	// }
	// }, [filterData, data.length, type]);

	const handleCheckbox = (e, title) => {
		let { value, checked, name } = e.target;
		const dispatchFilterItem = (item) => {
			dispatch(
				storeItemInGlobalFilter({
					name: filterFieldType[type]['idName'],
					key: item.id,
					value: item.name,
					identifier: `${filterFieldType[type]['idName']}_${item.id}`,
					checked: checked
				})
			);
		};

		if (title === 'All') {
			if (filterData[filterFieldKey]) {
				data.forEach((item) => {
					if (!filterData[filterFieldKey].some((fields) => fields?.key === item?.key)) {
						dispatchFilterItem(item);
					}
				});
			} else {
				data.forEach(dispatchFilterItem);
			}
		} else {
			let data = {
				name: filterFieldType[type]['idName'],
				key: value,
				value: title,
				identifier: name,
				checked: checked
			};
			dispatch(storeItemInGlobalFilter(data));
		}
	};

	const onOutSideClick = () => {
		dispatch(storeSelectedFilterCheckboxType(null));
	};
	useClickOutside(checkboxRef, onOutSideClick);
	return (
		selectedField?.selectedCheckboxField === type && (
			<div className={`filter-submenu scroll-y-label`} ref={checkboxRef}>
				<div className="card border-0">
					<div className="card-body">
						<div className="form-group size36 m-0 search-filter mb-3">
							<div className="with-icon right-icon">
								<input
									type="text"
									placeholder="Search"
									onChange={handleSearch}
									autoFocus={true}
									autoComplete="off"
								/>
								<span className="right-icon">
									<img src={`${process.env.PUBLIC_URL}/icons/search.png`} alt="" />
								</span>
							</div>
						</div>
						{data?.map((item) => (
							<div className="custom-chekbox" key={item?.id}>
								<div className="form-group certificate-group">
									<input
										type="checkbox"
										id={`${filterFieldType[type]['idName']}_${item.id}`}
										name={`${filterFieldType[type]['idName']}_${item.id}`}
										value={item.id}
										onChange={(e) => handleCheckbox(e, item.name)}
										checked={toggleCheckbox(
											filterData,
											filterFieldType[type]['idName'],
											`${filterFieldType[type]['idName']}_${item.id}`,
											item.key
										)}
									/>
									<label
										className="regular-14 d-flex align-items-center"
										htmlFor={`${filterFieldType[type]['idName']}_${item.id}`}
									>
										<span>
											{item?.name}{' '}
											{item?.type && item.type === 'USER_STAKEHOLDER_CUSTOMER_TAG'
												? '(Buyer)'
												: item.type === 'USER_STAKEHOLDER_SUPPLIER_TAG'
													? '(Supplier)'
													: ''}
										</span>
									</label>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		)
	);
};

export default CheckBoxWithAll;
